function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Spinner } from 'react-bootstrap';
import { Skeleton, Button, Tag, Modal, Space, ConfigProvider, notification, Dropdown, Alert, Drawer, Statistic, Divider, Form, Input, Select } from 'antd';
import Common from "../includes/Common";
import Moment from 'react-moment';
import { useOutletContext } from "react-router-dom";
import { NodePlusFill, TicketPerforatedFill, EyeFill, CartPlusFill, TrashFill, ThreeDots, PencilSquare, PencilFill, PrinterFill, PeopleFill } from 'react-bootstrap-icons';
import AddPricePlan from "./forms/AddPricePlan";
import EditEvent from "./forms/EditEvent";
import TicketsList from "../../admin/admin-components/TicketsList";
import AddTicket from "../../admin/admin-forms/AddTickets";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import OrderPrintedTickets from "./forms/OrderPrintedTickets";
import EventDetails from "../EventDetails";
import EditPricePlan from "./forms/EditPricePlan";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var EventDashboard = function EventDashboard(_ref) {
  var event_id = _ref.event_id,
    _handler = _ref.handler;
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    contextHolder = _Modal$useModal2[1];
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    event = _useState2[0],
    setEvent = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showPriceBox = _useState4[0],
    setShowPriceBox = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showEditForm = _useState6[0],
    setShowEditForm = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isDataChanged = _useState8[0],
    setIsDataChanged = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedPlan = _useState10[0],
    setSelectedPlan = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedEventTickets = _useState12[0],
    setSelectedEventTickets = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    priceSchemaItems = _useState14[0],
    setPriceSchemaItems = _useState14[1];
  var _useOutletContext = useOutletContext(),
    handleShowEventDetails = _useOutletContext.handleShowEventDetails;
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isAddAgentLoading = _useState16[0],
    setIsAddAgentLoading = _useState16[1];
  var _useState17 = useState(""),
    _useState18 = _slicedToArray(_useState17, 2),
    addAgentError = _useState18[0],
    setAddAgentError = _useState18[1];
  var _useState19 = useState(""),
    _useState20 = _slicedToArray(_useState19, 2),
    addAgentSuccess = _useState20[0],
    setAddAgentSuccess = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    isAgentListLoading = _useState22[0],
    setIsAgentListLoading = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    isEventTicketsLoading = _useState24[0],
    setIsEventTicketsLoading = _useState24[1];
  var _useState25 = useState(0),
    _useState26 = _slicedToArray(_useState25, 2),
    ticketDesignToken = _useState26[0],
    setTicketDesignToken = _useState26[1];
  var _useState27 = useState(false),
    _useState28 = _slicedToArray(_useState27, 2),
    showEditPlan = _useState28[0],
    setShowEditPlan = _useState28[1];
  var _useState29 = useState(0),
    _useState30 = _slicedToArray(_useState29, 2),
    totalTicketsCount = _useState30[0],
    setTotalTicketCount = _useState30[1];
  var _useState31 = useState(0),
    _useState32 = _slicedToArray(_useState31, 2),
    totalTicketsPrice = _useState32[0],
    setTotalTicketsPrice = _useState32[1];
  var _useState33 = useState(0),
    _useState34 = _slicedToArray(_useState33, 2),
    totalUsedTickets = _useState34[0],
    setTotalUsedTickets = _useState34[1];
  var _useState35 = useState(0),
    _useState36 = _slicedToArray(_useState35, 2),
    totalUsedTicketsPrice = _useState36[0],
    setTotalUsedTicketsPrice = _useState36[1];
  var _useState37 = useState([]),
    _useState38 = _slicedToArray(_useState37, 2),
    ticketsDetails = _useState38[0],
    setTicketsDetails = _useState38[1];
  var _useState39 = useState(0),
    _useState40 = _slicedToArray(_useState39, 2),
    totalSold = _useState40[0],
    setTotalSold = _useState40[1];
  var _useState41 = useState(0),
    _useState42 = _slicedToArray(_useState41, 2),
    amountSold = _useState42[0],
    seetAmountSold = _useState42[1];
  var _useState43 = useState(0),
    _useState44 = _slicedToArray(_useState43, 2),
    totalAv = _useState44[0],
    setTotalAv = _useState44[1];
  var _useState45 = useState([]),
    _useState46 = _slicedToArray(_useState45, 2),
    ticketsList = _useState46[0],
    setTicketsList = _useState46[1];
  var _useState47 = useState([]),
    _useState48 = _slicedToArray(_useState47, 2),
    usedList = _useState48[0],
    setUsedList = _useState48[1];
  var _useState49 = useState(false),
    _useState50 = _slicedToArray(_useState49, 2),
    showAddTickets = _useState50[0],
    setShowAddTickets = _useState50[1];
  var _useState51 = useState(false),
    _useState52 = _slicedToArray(_useState51, 2),
    showPrintTickets = _useState52[0],
    setShowPrintTickets = _useState52[1];
  var _useState53 = useState([]),
    _useState54 = _slicedToArray(_useState53, 2),
    eventAgents = _useState54[0],
    setEventAgents = _useState54[1];
  var _useState55 = useState(""),
    _useState56 = _slicedToArray(_useState55, 2),
    feedError = _useState56[0],
    setFeedError = _useState56[1];
  var _useState57 = useState(false),
    _useState58 = _slicedToArray(_useState57, 2),
    isAgentUpdateProcessing = _useState58[0],
    setIsAgentUpdateProcessing = _useState58[1];
  var _useState59 = useState(false),
    _useState60 = _slicedToArray(_useState59, 2),
    isPsUpdateProcessing = _useState60[0],
    setIsPsUpdateProcessing = _useState60[1];
  var _useState61 = useState(""),
    _useState62 = _slicedToArray(_useState61, 2),
    showPurchaseTickets = _useState62[0],
    setShowPurchaseTickets = _useState62[1];
  var _useState63 = useState(false),
    _useState64 = _slicedToArray(_useState63, 2),
    isDataLoading = _useState64[0],
    setIsDataLoading = _useState64[1];
  var ref = useRef();
  var handlePriceSchemaClick = function handlePriceSchemaClick(e) {};
  var handleAgentMenuClick = function handleAgentMenuClick(e) {};
  var handleDelete = function handleDelete(e) {
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["La supression de ", e.label]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "deleteevent", {
          user_id: Common.currentUser.id,
          event_id: e.id
        }).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "OK",
              description: "L'évènement à été supprimé !"
            });
          } else {
            notification.error({
              message: "Erreur",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur",
            description: "Une erreur est survenue"
          });
        });
      }
    });
  };
  useEffect(function () {
    setIsDataChanged(false);
    setIsAgentListLoading(true);
    axios.get(Common.baseApiUrl + "geteventagents/" + event_id + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setEventAgents([]);
        setEventAgents(response.data.agents);
      } else {
        setAddAgentError(response.data.message);
      }
    })["catch"](function (error) {
      setAddAgentError("Une erreur est survenue " + error.toString());
    })["finally"](function () {
      setIsAgentListLoading(false);
    });
  }, [isDataChanged]);
  useEffect(function () {
    setIsEventTicketsLoading(true);
    setIsDataLoading(true);
    setIsDataChanged(false);
    axios.get("".concat(Common.baseApiUrl, "geteventdata/").concat(event_id, "/").concat(Common.currentUser.id)).then(function (response) {
      if (response.data.status == 200) {
        setEvent(response.data.event);
        setPriceSchemaItems(response.data.event.price_schema_items);
        setTotalTicketCount(response.data.total_tickets);
        setTotalTicketsPrice(response.data.total_tickets_price);
        setTotalUsedTickets(response.data.total_scanned_tickets);
        setTotalUsedTicketsPrice(response.data.total_scanned_tickets_price);
        setTicketsDetails(response.data.ticket_details);
      } else {
        setFeedError(response.data.message);
      }
    })["catch"](function (error) {
      setFeedError("Une erreur est survenue");
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [event_id, isDataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
      active: true
    }), event != null && /*#__PURE__*/_jsx("div", {
      className: "white-bg feed-box",
      children: /*#__PURE__*/_jsxs(Container, {
        children: [/*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            lg: 12,
            children: /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(Container, {
                children: /*#__PURE__*/_jsxs(Row, {
                  children: [/*#__PURE__*/_jsx(Col, {
                    lg: 2,
                    md: 2,
                    sm: 3,
                    xs: 4,
                    children: /*#__PURE__*/_jsx("img", {
                      src: event.image_file,
                      style: {
                        width: '100%'
                      }
                    })
                  }), /*#__PURE__*/_jsxs(Col, {
                    lg: 6,
                    md: 3,
                    sm: 6,
                    xs: 5,
                    children: [/*#__PURE__*/_jsx("h6", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: event.label
                      })
                    }), /*#__PURE__*/_jsxs(Space, {
                      direction: "vertical",
                      children: [/*#__PURE__*/_jsxs(Space, {
                        direction: "horizontal",
                        children: [/*#__PURE__*/_jsxs(Button, {
                          type: "link",
                          onClick: function onClick() {
                            handleShowEventDetails(event);
                          },
                          children: [" ", /*#__PURE__*/_jsx("b", {
                            children: " DETAILS"
                          })]
                        }), /*#__PURE__*/_jsx(Button, {
                          type: "link",
                          onClick: function onClick() {
                            setShowEditForm(true);
                          },
                          children: /*#__PURE__*/_jsx("b", {
                            children: /*#__PURE__*/_jsx(PencilFill, {
                              size: 18
                            })
                          })
                        }), /*#__PURE__*/_jsx(Button, {
                          type: "link",
                          onClick: function onClick() {
                            handleDelete(event);
                          },
                          children: /*#__PURE__*/_jsx("b", {
                            children: /*#__PURE__*/_jsx(TrashFill, {
                              size: 18
                            })
                          })
                        })]
                      }), /*#__PURE__*/_jsxs(Space, {
                        direction: "horizontal",
                        children: [/*#__PURE__*/_jsx(Button, {
                          size: "large",
                          type: "primary",
                          onClick: function onClick() {
                            setShowAddTickets(true);
                          },
                          children: /*#__PURE__*/_jsxs("b", {
                            children: [" ", /*#__PURE__*/_jsx(NodePlusFill, {
                              size: 16
                            }), " Cr\xE9er des tickets"]
                          })
                        }), /*#__PURE__*/_jsx(Button, {
                          size: "large",
                          onClick: function onClick() {
                            setShowPurchaseTickets(true);
                          },
                          type: "default",
                          style: {
                            background: "#EBA72B",
                            color: "#432C16"
                          },
                          children: /*#__PURE__*/_jsxs("b", {
                            children: ["Commander des tickets ", /*#__PURE__*/_jsx(CartPlusFill, {
                              size: 18
                            })]
                          })
                        })]
                      })]
                    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
                  }), /*#__PURE__*/_jsxs(Col, {
                    lg: {
                      span: 3,
                      offset: 1
                    },
                    md: {
                      span: 3,
                      offset: 1
                    },
                    sm: {
                      span: 2,
                      offset: 1
                    },
                    xs: {
                      span: 2,
                      offset: 1
                    },
                    children: [/*#__PURE__*/_jsx(Tag, {
                      color: "#f50",
                      children: event.event_category.label
                    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Space, {
                      direction: "horizontal",
                      children: [/*#__PURE__*/_jsx("h1", {
                        style: {
                          padding: "15px",
                          color: "#FFFFFF",
                          borderRadius: "4px",
                          background: "#EB9800"
                        },
                        children: new Date(event.starts_at).getDay()
                      }), /*#__PURE__*/_jsxs("h5", {
                        children: [new Date(event.starts_at).toLocaleDateString('Fr', {
                          month: 'long'
                        }), " ", new Date(event.starts_at).getFullYear()]
                      })]
                    })]
                  })]
                })
              })
            })
          })
        }), /*#__PURE__*/_jsx(Divider, {
          children: "R\xE9sum\xE9 des ventes"
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 6,
            sm: 12,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                background: "#E8E6E3",
                padding: "5px",
                borderRadius: "4px"
              },
              children: /*#__PURE__*/_jsx(Statistic, {
                title: /*#__PURE__*/_jsx("b", {
                  children: "Nbre Tickets"
                }),
                value: totalTicketsCount.toLocaleString("Fr")
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 6,
            sm: 12,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                background: "#E8E6E3",
                padding: "5px",
                borderRadius: "4px"
              },
              children: /*#__PURE__*/_jsx(Statistic, {
                title: /*#__PURE__*/_jsx("b", {
                  children: "Montant tickets"
                }),
                value: totalTicketsPrice.toLocaleString("Fr")
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 6,
            sm: 12,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                background: "#E8E6E3",
                padding: "5px",
                borderRadius: "4px"
              },
              children: /*#__PURE__*/_jsx(Statistic, {
                title: /*#__PURE__*/_jsx("b", {
                  children: "Nbre scan\xE9s"
                }),
                value: totalUsedTickets.toLocaleString("Fr")
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 6,
            sm: 12,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                background: "#E8E6E3",
                padding: "5px",
                borderRadius: "4px"
              },
              children: /*#__PURE__*/_jsx(Statistic, {
                title: /*#__PURE__*/_jsx("b", {
                  children: "Montant scan\xE9s"
                }),
                value: totalUsedTicketsPrice.toLocaleString("Fr")
              })
            })
          })]
        }), /*#__PURE__*/_jsx("br", {}), ticketsDetails.map(function (d) {
          return /*#__PURE__*/_jsxs(Row, {
            style: {
              marginBottom: "10px"
            },
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 6,
              sm: 12,
              children: /*#__PURE__*/_jsx("div", {
                style: {
                  background: "#E8E6E3",
                  padding: "5px",
                  borderRadius: "4px"
                },
                children: /*#__PURE__*/_jsx(Statistic, {
                  title: /*#__PURE__*/_jsx("b", {
                    children: d.label
                  }),
                  value: d.total_tickets.toLocaleString("Fr")
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 6,
              sm: 12,
              children: /*#__PURE__*/_jsx("div", {
                style: {
                  background: "#E8E6E3",
                  padding: "5px",
                  borderRadius: "4px"
                },
                children: /*#__PURE__*/_jsx(Statistic, {
                  title: /*#__PURE__*/_jsx("b", {
                    children: "Montant"
                  }),
                  value: d.total_tickets_price.toLocaleString("Fr")
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 6,
              sm: 12,
              children: /*#__PURE__*/_jsx("div", {
                style: {
                  background: "#E8E6E3",
                  padding: "5px",
                  borderRadius: "4px"
                },
                children: /*#__PURE__*/_jsx(Statistic, {
                  title: /*#__PURE__*/_jsx("b", {
                    children: "Nbre scan\xE9s"
                  }),
                  value: d.total_scanned_tickets.toLocaleString("Fr")
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 6,
              sm: 12,
              children: /*#__PURE__*/_jsx("div", {
                style: {
                  background: "#E8E6E3",
                  padding: "5px",
                  borderRadius: "4px"
                },
                children: /*#__PURE__*/_jsx(Statistic, {
                  title: /*#__PURE__*/_jsx("b", {
                    children: "Montant scan\xE9s"
                  }),
                  value: d.total_scanned_tickets_price.toLocaleString("Fr")
                })
              })
            })]
          }, d.id);
        }), /*#__PURE__*/_jsx(Divider, {
          children: "Liste des acc\xE8s"
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            children: /*#__PURE__*/_jsxs(Space, {
              direction: "vertical",
              children: [/*#__PURE__*/_jsxs(Button, {
                type: "link",
                onClick: function onClick() {
                  setShowPriceBox(true);
                },
                icon: /*#__PURE__*/_jsx(TicketPerforatedFill, {}),
                children: [" ", /*#__PURE__*/_jsx("b", {
                  children: " AJOUTER UN ACCES"
                })]
              }), event.price_schema_items.length == 0 && /*#__PURE__*/_jsx(Alert, {
                type: "error",
                message: "Vous n'avez pas mis en place de pass",
                banner: true,
                showIcon: true
              })]
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 8,
            md: 8,
            children: /*#__PURE__*/_jsx(Space, {
              direction: "horizontal",
              wrap: true,
              children: priceSchemaItems.map(function (i) {
                return /*#__PURE__*/_jsxs(Space.Compact, {
                  block: true,
                  children: [/*#__PURE__*/_jsx(Button, {
                    loading: isPsUpdateProcessing,
                    type: "default",
                    children: /*#__PURE__*/_jsxs("b", {
                      children: [i.label, "(", i.price.toLocaleString('Fr'), " GNF)"]
                    })
                  }), contextHolder, /*#__PURE__*/_jsx(Dropdown, {
                    placement: "bottomRight",
                    menu: {
                      onClick: function onClick(e) {
                        if (e.key == 1) {
                          //EDIT
                          setSelectedPlan(i);
                          setShowEditPlan(true);
                        }
                        if (e.key == 2) {
                          //DELETE
                          confirm({
                            title: /*#__PURE__*/_jsx("b", {
                              children: "Confirmez-vous ?"
                            }),
                            content: /*#__PURE__*/_jsxs("p", {
                              children: ["La suppression du pass ", i.label]
                            }),
                            onOk: function onOk() {
                              setIsPsUpdateProcessing(true);
                              axios.post(Common.baseApiUrl + "deletepriceschema", {
                                id: i.id,
                                user_id: Common.currentUser.id
                              }).then(function (response) {
                                if (response.data.status == 200) {
                                  notification.success({
                                    message: "Ok!",
                                    description: response.data.message
                                  });
                                  setIsDataChanged(true);
                                } else {
                                  notification.error({
                                    message: "Oops!",
                                    description: response.data.message
                                  });
                                }
                              })["catch"](function (error) {
                                notification.error({
                                  message: "Oops!",
                                  description: "Une erreur est survenue " + error.toString()
                                });
                              })["finally"](function () {
                                setIsPsUpdateProcessing(false);
                              });
                            }
                          });
                        }
                      },
                      items: [{
                        key: 1,
                        label: "Modifier",
                        icon: /*#__PURE__*/_jsx(PencilSquare, {
                          size: 18
                        })
                      }, {
                        key: 2,
                        label: "Supprimer",
                        icon: /*#__PURE__*/_jsx(TrashFill, {
                          size: 18
                        })
                      }]
                    },
                    trigger: ['click'],
                    children: /*#__PURE__*/_jsx(Button, {
                      type: "default",
                      icon: /*#__PURE__*/_jsx(ThreeDots, {
                        size: 18
                      })
                    })
                  })]
                });
              })
            })
          })]
        }), /*#__PURE__*/_jsx(Divider, {
          children: "Agents flasheurs"
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            children: /*#__PURE__*/_jsxs(Form, {
              layout: "vertical",
              onFinish: function onFinish(values) {
                setIsAddAgentLoading(true);
                setAddAgentError("");
                setAddAgentSuccess("");
                axios.get(Common.baseApiUrl + "getsingleuserfrommobile/" + values.agent_mobile).then(function (response) {
                  if (response.data.status == 200) {
                    confirm({
                      title: /*#__PURE__*/_jsx("b", {
                        children: "Confirmez-vous ?"
                      }),
                      content: /*#__PURE__*/_jsxs("p", {
                        children: ["L'ajout de l'utilisateur ", response.data.user.mobile.slice(3), " \xE0 vos agents flasheurs ?"]
                      }),
                      cancelText: "Annuler",
                      onOk: function onOk() {
                        axios.post(Common.baseApiUrl + "addeventagent", {
                          event_id: event.id,
                          user_id: Common.currentUser.id,
                          agent_id: response.data.user.id
                        }).then(function (ar) {
                          if (ar.data.status == 200) {
                            setAddAgentSuccess(ar.data.message);
                            setIsDataChanged(true);
                          } else {
                            setAddAgentError(ar.data.message);
                          }
                        })["catch"](function (error) {
                          setAddAgentError("Une erreur est survenue " + error.toString());
                        })["finally"](function () {
                          setIsAddAgentLoading(false);
                        });
                      }
                    });
                  } else {
                    setAddAgentError(response.data.message);
                  }
                })["catch"](function (error) {
                  setAddAgentError("Une erreur est survenue " + error.toString());
                })["finally"](function () {
                  setIsAddAgentLoading(false);
                });
              },
              children: [/*#__PURE__*/_jsxs(Space, {
                direction: "horizontal",
                children: [/*#__PURE__*/_jsx(Form.Item, {
                  name: "agent_mobile",
                  children: /*#__PURE__*/_jsx(Input, {
                    placeholder: "Num\xE9ro mobile"
                  })
                }), /*#__PURE__*/_jsxs(Form.Item, {
                  children: [contextHolder, /*#__PURE__*/_jsx(Button, {
                    loading: isAddAgentLoading,
                    icon: /*#__PURE__*/_jsx(PeopleFill, {}),
                    type: "primary",
                    htmlType: "submit",
                    children: /*#__PURE__*/_jsx("b", {
                      children: "Ajouter"
                    })
                  })]
                })]
              }), addAgentError.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Alert, {
                  type: "error",
                  message: addAgentError,
                  banner: true
                })
              }), addAgentSuccess.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Alert, {
                  type: "success",
                  message: addAgentSuccess,
                  banner: true
                })
              })]
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 8,
            md: 0,
            children: /*#__PURE__*/_jsx(Space, {
              direction: "horizontal",
              wrap: true,
              children: eventAgents.length > 0 && eventAgents.map(function (i) {
                return /*#__PURE__*/_jsxs(Space.Compact, {
                  block: true,
                  direction: "horizontal",
                  children: [/*#__PURE__*/_jsx(Button, {
                    loading: isAgentUpdateProcessing,
                    type: "default",
                    children: /*#__PURE__*/_jsxs("b", {
                      children: [i.user.firstname, " ", i.user.lastname]
                    })
                  }), contextHolder, /*#__PURE__*/_jsx(Dropdown, {
                    placement: "bottomRight",
                    menu: {
                      onClick: function onClick(e) {
                        if (e.key == 1) {
                          //REMOVE AGENT  
                          confirm({
                            title: /*#__PURE__*/_jsx("b", {
                              children: "Confirmez-vous ?"
                            }),
                            content: /*#__PURE__*/_jsxs("p", {
                              children: ["Le retrait de l'agent ", /*#__PURE__*/_jsxs("b", {
                                children: [i.user.firstname, " ", i.user.lastname]
                              }), " ?"]
                            }),
                            cancelText: "Annuler",
                            onOk: function onOk() {
                              setIsAgentUpdateProcessing(true);
                              axios.post(Common.baseApiUrl + "removeeventagent", {
                                id: i.id,
                                user_id: Common.currentUser.id
                              }).then(function (response) {
                                if (response.data.status == 200) {
                                  notification.success({
                                    message: "Ok!",
                                    description: response.data.message
                                  });
                                  setIsDataChanged(true);
                                } else {
                                  notification.error({
                                    message: "Oops!",
                                    description: response.data.message
                                  });
                                }
                              })["catch"](function (error) {
                                notification.error({
                                  message: "Oops!",
                                  description: "Une erreur est survenue " + error.toString()
                                });
                              })["finally"](function () {
                                setIsAgentUpdateProcessing(false);
                              });
                            }
                          });
                        }
                      },
                      items: [{
                        key: 1,
                        label: "Supprimer",
                        icon: /*#__PURE__*/_jsx(TrashFill, {
                          size: 18
                        })
                      }]
                    },
                    trigger: ['click'],
                    children: /*#__PURE__*/_jsx(Button, {
                      type: "default",
                      icon: /*#__PURE__*/_jsx(ThreeDots, {
                        size: 18
                      })
                    })
                  })]
                }, i.id);
              })
            })
          })]
        })]
      })
    }), event != null && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: event.label
        }),
        open: showPriceBox,
        onCancel: function onCancel() {
          setShowPriceBox(false);
        },
        destroyOnClose: true,
        footer: null,
        width: "290px",
        centered: true,
        children: /*#__PURE__*/_jsx(AddPricePlan, {
          event: event,
          update: setPriceSchemaItems,
          handler: function handler() {
            setShowPriceBox(false);
            _handler();
            setIsDataChanged(true);
          }
        })
      }), selectedPlan && /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: event.label
        }),
        open: showEditPlan,
        onCancel: function onCancel() {
          setShowEditPlan(false);
        },
        destroyOnClose: true,
        footer: null,
        width: "290px",
        centered: true,
        children: /*#__PURE__*/_jsx(EditPricePlan, {
          plan: selectedPlan,
          event: event,
          handler: function handler() {
            setShowEditPlan(false);
            _handler();
            setIsDataChanged(true);
          }
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: event.label
        }),
        open: showEditForm,
        onClose: function onClose() {
          setShowEditForm(false);
        },
        destroyOnClose: true,
        width: "90%",
        children: /*#__PURE__*/_jsx(EditEvent, {
          event: event
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: "AJOUTER TICKETS",
        onCancel: function onCancel() {
          setShowAddTickets(false);
        },
        open: showAddTickets,
        destroyOnClose: true,
        width: "650px",
        footer: null,
        children: /*#__PURE__*/_jsx(AddTicket, {
          event: event,
          handler: function handler() {
            setShowAddTickets(false);
            _handler();
            notification.success({
              message: "Ok!",
              description: "Opération réussie!"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Modal, {
        open: showPurchaseTickets,
        onCancel: function onCancel() {
          setShowPurchaseTickets(false);
        },
        width: {
          xs: '95%',
          sm: '80%',
          md: '70%',
          lg: '60%',
          xl: '50%',
          xxl: '40%'
        },
        centered: true,
        footer: null,
        title: /*#__PURE__*/_jsx("h6", {
          style: {
            color: '#645D5D'
          },
          children: /*#__PURE__*/_jsx("b", {
            children: "Il est temps de commander plus de tickets"
          })
        }),
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx("div", {
          style: {
            padding: "22px"
          },
          children: /*#__PURE__*/_jsx(OrderPrintedTickets, {
            event: event,
            handler: function handler() {
              setIsDataChanged(true);
              setShowPurchaseTickets(false);
            }
          })
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "IMPRESSION"
        }),
        onClose: function onClose() {
          setShowPrintTickets(false);
        },
        open: showPrintTickets,
        destroyOnClose: true,
        width: "95%",
        extra: [/*#__PURE__*/_jsx(Select, {
          style: {
            margin: "0px 8px"
          },
          defaultValue: ticketDesignToken,
          options: [{
            label: "Standard",
            value: 0
          }, {
            label: "Bracelet",
            value: 1
          }],
          onChange: function onChange(v) {
            setTicketDesignToken(v);
          }
        }), /*#__PURE__*/_jsx(ReactToPrint, {
          content: function content() {
            return ref.current;
          },
          children: /*#__PURE__*/_jsx(PrintContextConsumer, {
            children: function children(_ref2) {
              var handlePrint = _ref2.handlePrint;
              return /*#__PURE__*/_jsx(Button, {
                type: "primary",
                onClick: handlePrint,
                children: /*#__PURE__*/_jsx("b", {
                  children: "IMPRIMER"
                })
              });
            }
          })
        })],
        children: /*#__PURE__*/_jsx(TicketsList, {
          design: ticketDesignToken,
          tickets: selectedEventTickets,
          ref: ref
        })
      })]
    }), /*#__PURE__*/_jsx("br", {})]
  });
};
export default EventDashboard;